import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import { useLocation } from 'react-router';
import { isHelixOnlyHub } from 'utils/helix/isHelixOnlyHub';
import PageSection from 'components/PageSection';
import PageBackLink from 'components/PageBackLink';
import UserPageHeader from 'components/UserPageHeader';
function SkillPageWrapper(_ref) {
  var user = _ref.user,
    fallbackLink = _ref.fallbackLink,
    children = _ref.children;
  var location = useLocation();
  var isProfilePage = location.pathname.includes('/profile');
  return /*#__PURE__*/React.createElement(React.Fragment, null, fallbackLink && /*#__PURE__*/React.createElement(PageSection, {
    flush: !user
  }, /*#__PURE__*/React.createElement(PageBackLink, {
    fallback: fallbackLink,
    mb: user ? '0' : 'xs',
    mt: isProfilePage && isHelixOnlyHub ? 'm' : '0'
  })), /*#__PURE__*/React.createElement(PageSection, {
    flush: true
  }, user && /*#__PURE__*/React.createElement(UserPageHeader, user), children));
}
export default SkillPageWrapper;